import React, { useMemo } from 'react';
import { ResponsiveAutocomplete } from '@/components/selects/ResponsiveAutocomplete';
import { useListAllBrokerGroupsQuery } from '../../brokerGroups/api/brokerGroupsApi';
import { LEDGER_SEARCH_OPTIONS } from '../searchOptions';
import { ADMIN_PICKER_OPTION_LIMIT } from './constants';
import { fuseFilterOptions } from './fuseFilterOptions';

const filterLedgers = fuseFilterOptions(LEDGER_SEARCH_OPTIONS);

/**
 * Pick ledgers: every distinct `ledger` across broker groups, searchable, listing at most
 * ADMIN_PICKER_OPTION_LIMIT matches at a time. value/onChange are
 * ledger names (an array when multiple, the default). excludeIds are left out of the
 * options. Other props go to ResponsiveAutocomplete.
 */
export const AdminLedgerPicker = ({ excludeIds = [], multiple = true, ...props }) => {
	const { data: brokerGroups, isLoading } = useListAllBrokerGroupsQuery();

	const options = useMemo(
		() =>
			[...new Set((brokerGroups ?? []).map((brokerGroup) => brokerGroup.ledger))]
				.filter((ledger) => ledger && !excludeIds.includes(ledger))
				.sort((a, b) => a.localeCompare(b)),
		[brokerGroups, excludeIds],
	);

	return (
		<ResponsiveAutocomplete
			options={options}
			multiple={multiple}
			searchable
			filterOptions={filterLedgers}
			optionLimit={ADMIN_PICKER_OPTION_LIMIT}
			loading={isLoading}
			disabled={isLoading}
			{...props}
		/>
	);
};
